import TogetherXAtena from './TogheterXAtena';
export default TogetherXAtena;
